import { LocalStorage } from '../../shared/services/local-storage.service';

export const hasProfileContext = (localStorageService: LocalStorage): boolean => {
    const subAdminDetails = localStorageService.getDataByKey('subAdminDetails');
    if (subAdminDetails) return true;

    const adminLoginResponse = localStorageService.getDataByKey('loginResponse');
    if (adminLoginResponse) return true;

    const adminName = localStorageService.getDataByKey('adminProfileName');
    const subAdminName = localStorageService.getDataByKey('subAdminProfileName');
    const adminOk = typeof adminName === 'string' && adminName.trim().length > 0;
    const subAdminOk = typeof subAdminName === 'string' && subAdminName.trim().length > 0;
    return adminOk || subAdminOk;
};
